import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "settings-list-element-root row no-wrap"
}
const _hoisted_2 = {
  key: 0,
  class: "q-my-auto"
}
const _hoisted_3 = {
  key: 1,
  class: "row justify-left full-width q-my-auto"
}
const _hoisted_4 = {
  key: 2,
  class: "settings-list-element-root row justify-left full-width no-wrap"
}
const _hoisted_5 = { class: "columns-selector-popup" }
const _hoisted_6 = { class: "columns-selector-subheader" }
const _hoisted_7 = { class: "columns-selector-subheader__label" }
const _hoisted_8 = { class: "columns-selector-popup__list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "columns-popup-node__chevron-placeholder"
}
const _hoisted_13 = { class: "columns-popup-node__label" }
const _hoisted_14 = { class: "col q-py-none" }
const _hoisted_15 = {
  key: 0,
  class: "q-my-auto",
  style: {"margin-top":"2px"}
}
const _hoisted_16 = {
  key: 1,
  class: "row justify-left full-width q-my-auto",
  style: {"margin-top":"2px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mosta_checkbox = _resolveComponent("mosta-checkbox")!
  const _component_settings_list_element = _resolveComponent("settings-list-element", true)!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_selector_search_header = _resolveComponent("selector-search-header")!
  const _component_selector_popup = _resolveComponent("selector-popup")!

  return (_ctx.isSelectable && (_ctx.beingSearched || _ctx.hasSearched))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_mosta_checkbox, {
          style: {"display":"flex !important"},
          "model-value": _ctx.elementModel.Selected,
          "onUpdate:modelValue": _ctx.selectElement
        }, null, 8, ["model-value", "onUpdate:modelValue"]),
        (_ctx.getSearchedName.length <= 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "full-width q-my-auto cursor-pointer",
              style: {"margin-left":"6px !important"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectElement && _ctx.selectElement(...args)))
            }, _toDisplayString(_ctx.getElementName), 1))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "row justify-left full-width q-my-auto cursor-pointer",
              style: {"margin-left":"6px !important"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectElement && _ctx.selectElement(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSearchedName, (span, i) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: i,
                  style: _normalizeStyle(span.style)
                }, _toDisplayString(span.text), 5))
              }), 128))
            ]))
      ]))
    : (!_ctx.isSelectable && !_ctx.isRoot && (_ctx.beingSearched || _ctx.hasSearched))
      ? (_openBlock(), _createBlock(_component_q_expansion_item, {
          key: 1,
          "switch-toggle-side": "",
          "expand-icon-toggle": "",
          dense: true,
          "dense-toggle": true,
          "model-value": /*hasSearched || */true,
          "expand-separator": "",
          icon: "expand_more",
          class: "setting-item q-my-xs"
        }, {
          header: _withCtx(() => [
            (_ctx.getSearchedName.length <= 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.getElementName), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSearchedName, (span, i) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: i,
                      style: _normalizeStyle(span.style)
                    }, _toDisplayString(span.text), 5))
                  }), 128))
                ]))
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.element as ColumnSendComposite).ChildColumns, (child) => {
              return (_openBlock(), _createBlock(_component_settings_list_element, {
                class: "setting-selection--child",
                element: child,
                key: (child as ColumnListItem).compound_id,
                "input-index": (child as ColumnListItem).compound_id,
                "parent-id": (child as ColumnListItem).compound_id,
                "parent-name": _ctx.getElementName,
                "parent-idx": (_ctx.elementModel as ColumnListItem).compound_id,
                "is-root": false,
                "search-string": !_ctx.beingSearched ? _ctx.searchString : '',
                "selector-popup-mode": _ctx.selectorPopupMode,
                onChangeSelection: _ctx.onChildUpdate
              }, null, 8, ["element", "input-index", "parent-id", "parent-name", "parent-idx", "search-string", "selector-popup-mode", "onChangeSelection"]))
            }), 128))
          ]),
          _: 1
        }))
      : (!_ctx.isSelectable && _ctx.isRoot)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_q_btn, {
              ref: "selector_trigger_btn",
              class: "q-my-none unset-items-center",
              flat: "",
              dense: "",
              round: "",
              icon: "add",
              size: "sm",
              color: "grey-8",
              "aria-label": _ctx.$t('expand_parameters_selector'),
              style: {"margin-left":"-5px !important"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.menuShowing = true))
            }, null, 8, ["aria-label"]),
            _createVNode(_component_selector_popup, {
              visible: _ctx.menuShowing,
              "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.menuShowing) = $event)),
              "trigger-el": _ctx.$refs.selector_trigger_btn,
              "default-width": 320,
              "min-width": 260,
              "max-width": 1200,
              "min-height": 220,
              "max-height": 700
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_selector_search_header, {
                    ref: "columns_search_header",
                    modelValue: _ctx.filter_string,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filter_string) = $event)),
                    "show-free-input": false,
                    "show-close-button": true,
                    onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.menuShowing = false))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getElementName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popupFlatRows, (row) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: row.key,
                        class: "columns-popup-node__row",
                        style: _normalizeStyle({ paddingLeft: `${row.depth * 22}px` }),
                        draggable: "false",
                        onClick: _withModifiers(($event: any) => (_ctx.onPopupRowClick(row)), ["stop","prevent"])
                      }, [
                        (row.hasChildren)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(["columns-popup-node__chevron", { 'columns-popup-node__chevron--closed': !_ctx.popupIsExpanded(row.key) }]),
                              onClick: _withModifiers(($event: any) => (_ctx.togglePopupExpand(row.key)), ["stop","prevent"])
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.chevronDownSvg,
                                class: "columns-popup-node__chevron-icon",
                                draggable: "false"
                              }, null, 8, _hoisted_11)
                            ], 10, _hoisted_10))
                          : (_openBlock(), _createElementBlock("span", _hoisted_12)),
                        (row.selectable)
                          ? (_openBlock(), _createBlock(_component_mosta_checkbox, {
                              key: 2,
                              class: "columns-popup-node__check",
                              "model-value": !!(row.node as ColumnSendSelectable).Selected,
                              "onUpdate:modelValue": ($event: any) => (_ctx.onPopupCheckboxUpdate(row, $event)),
                              onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                            }, null, 8, ["model-value", "onUpdate:modelValue"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.labelSpans, (span, i) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: i,
                              style: _normalizeStyle(span.style)
                            }, _toDisplayString(span.text), 5))
                          }), 128))
                        ])
                      ], 12, _hoisted_9))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible", "trigger-el"]),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.getSearchedName.length <= 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.getElementName), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSearchedName, (span, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: i,
                        style: _normalizeStyle(span.style)
                      }, _toDisplayString(span.text), 5))
                    }), 128))
                  ]))
            ])
          ]))
        : _createCommentVNode("", true)
}